export default function CallCenterSection() {
  const phones = [
    { flag: '🇹🇷', number: '+90 532 237 65 76', label: 'Türkiye Ana Hat', href: 'tel:+905322376576', primary: true },
    { flag: '🇩🇪', number: '+49 177 595 87 62', label: 'Almanya Hat 1', href: 'tel:+491775958762', primary: false },
    { flag: '🇩🇪', number: '+49 162 243 76 27', label: 'Almanya Hat 2', href: 'tel:+491622437627', primary: false },
  ];

  return (
    <section id="call-center" className="relative py-20 md:py-28 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="/media/1a1f85b4-0107-42d3-b1bb-2d1c9d748f12_bbbb-687681e219.png"
          alt="Çağrı Merkezi"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/80"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-flex items-center gap-2 bg-brand-orange/25 border border-brand-orange/50 text-brand-orange px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <span className="w-2 h-2 bg-brand-orange rounded-full animate-pulse"></span>
              7/24 Aktif
            </div>
            <h2 className="text-white font-heading font-bold text-3xl md:text-4xl mb-6 leading-tight drop-shadow-lg">
              Her An Yanınızdayız —
              <br />
              <span className="text-brand-orange">Çağrı Merkezi</span> 7/24 Açık
            </h2>
            <p className="text-gray-200 text-base md:text-lg mb-10 leading-relaxed">
              Gece 02:00'de acil bir taşıma mı gerekti? Sabahın ilk saatlerinde fiyat mı sormak istiyorsunuz? Fark etmez — uzmanlarımız her zaman hatta.
            </p>

            <div className="grid grid-cols-2 gap-4 mb-10">
              {[
                { icon: 'ri-phone-line', label: 'Doğrudan Hat', value: 'Bekleme Yok' },
                { icon: 'ri-global-line', label: 'Dil Desteği', value: 'TR & DE' },
                { icon: 'ri-time-line', label: 'Yanıt Süresi', value: '&lt; 30 sn' },
                { icon: 'ri-shield-check-line', label: 'Hizmet', value: '365 Gün' },
              ].map((item) => (
                <div key={item.label} className="bg-white/15 border border-white/20 rounded-xl p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="w-6 h-6 flex items-center justify-center text-brand-orange">
                      <i className={`${item.icon} text-lg`}></i>
                    </span>
                    <span className="text-gray-300 text-xs font-medium">{item.label}</span>
                  </div>
                  <div className="text-white font-bold text-base" dangerouslySetInnerHTML={{ __html: item.value }}></div>
                </div>
              ))}
            </div>
          </div>

          {/* Right - Phone List */}
          <div className="space-y-4">
            {phones.map((phone) => (
              <a
                key={phone.number}
                href={phone.href}
                className={`group flex items-center gap-5 p-5 rounded-lg border transition-all duration-300 hover:-translate-y-0.5 cursor-pointer ${
                  phone.primary
                    ? 'bg-white/10 border-brand-orange text-white ring-1 ring-brand-orange/30'
                    : 'bg-white/5 border-white/10 text-white hover:bg-white/10 hover:border-white/25'
                }`}
              >
                <div className={`w-14 h-14 flex items-center justify-center rounded-lg text-2xl flex-shrink-0 ${
                  phone.primary ? 'bg-brand-orange/20 border border-brand-orange/30' : 'bg-white/10'
                }`}>
                  {phone.flag}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-xs text-gray-300 font-medium mb-0.5">{phone.label}</div>
                  <div className="font-heading font-bold text-xl text-white">{phone.number}</div>
                </div>
                <div className={`w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0 transition-transform group-hover:scale-110 ${
                  phone.primary ? 'bg-brand-orange text-white' : 'bg-white/10 text-white'
                }`}>
                  <i className="ri-phone-fill text-lg"></i>
                </div>
              </a>
            ))}

            {/* Email */}
            <div className="group flex items-center gap-5 p-5 rounded-lg border border-white/10 bg-white/5 hover:bg-white/10 hover:border-white/25 text-white transition-all duration-300 hover:-translate-y-0.5">
              <div className="w-14 h-14 flex items-center justify-center rounded-lg bg-white/10 flex-shrink-0">
                <i className="ri-mail-line text-2xl text-brand-orange"></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-xs text-gray-300 font-medium mb-0.5">E-Posta</div>
                <a href="mailto:Mustafa@tolelojistik.com.tr" className="block font-medium text-sm text-white hover:text-brand-orange transition-colors truncate">
                  Mustafa@tolelojistik.com.tr
                </a>
                <a href="mailto:serkan@tolelojistik.com.tr" className="block font-medium text-sm text-white hover:text-brand-orange transition-colors truncate">
                  serkan@tolelojistik.com.tr
                </a>
              </div>
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 flex-shrink-0">
                <i className="ri-arrow-right-up-line text-lg"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
